import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'
import Custom from './custom'

const state = {
  currentFiscalYearId: 0,
  commonObj: {
    hasDropdownLoaded: false,
    perPage: 10,
    dateFormat: 'dd/mm/YYYY',
    timeFormat: 'h:m',
    loading: false,
    listReload: false,
    trainingTypeList: [],
    trainingCategoryList: [],
    trainingTitleList: [],
    roomTypeList: [],
    roomRentList: [],
    accomodationSetupList: [],
    courseDocumentSetupList: [],
    faqSetupList: [],
    trainingQuarterSetupList: [],
    foodPackageList: [],
    traineeEvaluationList: [],
    venus: [],
    courseList: [],
    trainerEvaluationList: [],
    courseModuleList: [],
    // personalInfoList: [],
    guestHouseList: [],
    paymentType: Custom.paymentType,
    jobTypeList: Custom.jobTypeList,
    userPriceTypeList: Custom.userPriceTypeList,
    userRentTypeList: Custom.userRentTypeList,
    subCenterUserRentTypeList: Custom.subCenterUserRentTypeList,
    genderList: Custom.genderList,
    sheduleType: Custom.sheduleType,
    roomUserTypeList: Custom.roomUserTypeList,
    committeeType: Custom.committeeType,
    roomList: [],
    gradingStatus: [],
    floorList: [],
    trainingScheduleSetup: [],
    sessonType: [],
    trainingExpertiseList: [],
    trainingReportHeadList: [],
    duplicateCertificateFeeList: [],
    otherTraineeTypeList: [],
    roomTypeSetupList: [],
    roomRentSetupList: []
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
